<template>
    <div>
        <v-card>
            <v-card-title>Two-Factor Authentication is Required.</v-card-title>
            <v-card-text>
                <div
                    v-if="status === 'unverified'">
                    <strong>We will send you a code via SMS.</strong>
                    <div>
                        <v-text-field
                            label="Please enter your phone number. Ex: XXX-XXX-XXXX or XXXXXXXXXX"
                            v-model="phone"></v-text-field>
                        <span v-if="getError('verification_phone')" style="color: red;display: block;">{{ getError('verification_phone')}}</span>
                        <v-btn
                            class="mt-2"
                            color="blue"
                            type="button"
                            @click="() => this.$emit('requested', this.phone)">
                            <span>Okay Send Me a 6-digit code</span></v-btn>
                    </div>
                </div>
                <div v-if="status === 'requested' || status === 'failed'">
                    <strong v-if="status === 'requested'">The code has been sent to {{ phoneProp }}. Please wait for and enter the 6-digit code below.</strong>
                    <strong style="color: red;" v-else>Authentication failed. Please try again.</strong>
                    <div style="display: flex">
                        <v-text-field v-model="code"></v-text-field>
                        <v-btn
                            class="mt-2 ml-2"
                            color="success"
                            type="button"
                            @click="() => this.$emit('submitted', this.code)">Verify</v-btn>
                   </div>
                    <strong>Didn't receive your code?</strong>
                    <div style="display: flex">
                        <v-text-field
                            label="Please confirm your phone number. Ex: XXX-XXX-XXXX or XXXXXXXXXX"
                            v-model="phone"></v-text-field>
                        <span v-if="getError('verification_phone')" style="display: block;color: red;">{{ getError('verification_phone')}}</span>
                        <v-btn
                            class="mt-2 ml-2 white--text"
                            color="blue"
                            type="button"
                            @click="() => {this.code = null; this.$emit('requested', phone)}">Try Again</v-btn>
                    </div>
                </div>
                <div v-if="status === 'expired'">
                    <div><strong style="color: red;">Sorry the code has expired, please try again.</strong></div>
                    <v-btn
                        class="mt-2 white--text"
                        color="blue"
                        type="button"
                        @click="() => {this.code = null; this.$emit('requested')}">Send Me a New Code</v-btn>
                </div>
                <loader v-if="status === 'processing'"/>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Loader from "@/components/Loader";
import {mapGetters} from 'vuex';
export default {
    components: {Loader},

    props: {
        status: {
            type: String,
            default: 'unverified'
        },
        phoneProp: {
            type: String,
            default: '',
        }
    },

    computed: {
        ...mapGetters('formError', ['getError'])
    },

    data() {
        return {
            code: null,
            phone: this.phoneProp
        }
    },

    watch: {
        phoneProp() {
            this.phone = this.phoneProp;
        }
    }
}
</script>
